import { Link } from 'react-router-dom'
import { X, Maximize2, LayoutTemplate } from 'lucide-react'
import { ThemesManager } from './ThemesManager'

interface ThemeManagerDrawerProps {
  open: boolean
  onClose: () => void
  activeThemeId?: number | null
  onAssign?: (themeId: number | null) => void
}

/** Panneau latéral de gestion des thèmes, ouvert depuis l'icône palette du builder. */
export function ThemeManagerDrawer({ open, onClose, activeThemeId, onAssign }: ThemeManagerDrawerProps) {
  if (!open) return null
  return (
    <div className="fixed inset-0 z-[1000] flex justify-end">
      <div className="absolute inset-0 bg-[rgba(27,37,89,0.4)]" onClick={onClose} aria-hidden />
      <div className="relative flex h-full w-[92vw] max-w-[1100px] flex-col bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-[#E2E4ED] px-5 py-3">
          <h2 className="text-sm font-semibold text-[#1B2559]">Thèmes de rapport</h2>
          <div className="flex items-center gap-2">
            <Link to="/report-templates" className="flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium text-[#6366F1] hover:bg-[#F4F5FA]">
              <LayoutTemplate size={13} /> Templates
            </Link>
            <Link to="/themes" className="flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium text-[#6366F1] hover:bg-[#F4F5FA]">
              <Maximize2 size={13} /> Ouvrir en plein écran
            </Link>
            <button type="button" aria-label="Fermer" onClick={onClose} className="flex h-7 w-7 items-center justify-center rounded-md text-[#8B8FA7] hover:bg-[#F4F5FA] hover:text-[#1B2559]">
              <X size={16} />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-hidden">
          <ThemesManager activeThemeId={activeThemeId} onAssign={onAssign} />
        </div>
      </div>
    </div>
  )
}
